// @mui
import { alpha, styled } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
// hooks
import { useCollapseDrawer } from "hooks/useProvidersHooks";

const RootStyle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  margin: theme.spacing(2, 2.5),
  borderRadius: 14,
  backgroundColor: alpha(theme.palette.primary.main, 0.06),
  border: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
  transition: theme.transitions.create(
    ["opacity", "background-color", "border-color"],
    {
      duration: theme.transitions.duration.shorter,
    }
  ),
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    borderColor: alpha(theme.palette.primary.main, 0.15),
  },
}));

export default function NavbarAccount() {
  const user = JSON.parse(localStorage.getItem("user") as string);

  const { isCollapse } = useCollapseDrawer();
  return (
    <Link underline="none" color="inherit">
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: "transparent",
            border: "none",
          }),
        }}
      >
        <Avatar
          src="https://minimal-assets-api.vercel.app/assets/images/avatars/avatar_5.jpg"
          alt="Rayan Moran"
          sx={{
            width: 40,
            height: 40,
            border: (theme) =>
              `2.5px solid transparent`,
            background: (theme) =>
              `linear-gradient(${theme.palette.background.paper}, ${theme.palette.background.paper}) padding-box, linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main}) border-box`,
          }}
        />

        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create("width", {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
          }}
        >
          <Typography
            variant="subtitle2"
            noWrap
            fontWeight={700}
            sx={{ letterSpacing: "-0.01em" }}
          >
            {user?.username}
          </Typography>
        </Box>
      </RootStyle>
    </Link>
  );
}
